// extracted by mini-css-extract-plugin
module.exports = {"avatar":"CompanyAvatar_avatar__15C8p","small":"CompanyAvatar_small__2fVn-","medium":"CompanyAvatar_medium__xNGku","large":"CompanyAvatar_large__1EM_l"};